import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyesLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 0.75C14.2216 0.75 16.9062 3.07774 18.9551 7.35352C20.9778 11.5749 22.25 17.4595 22.25 24C22.25 30.5405 20.9778 36.4251 18.9551 40.6465C16.9062 44.9223 14.2216 47.25 11.5 47.25C8.77836 47.25 6.09376 44.9223 4.04492 40.6465C2.02216 36.4251 0.75 30.5405 0.75 24C0.75 17.4595 2.02216 11.5749 4.04492 7.35352C6.09376 3.07774 8.77836 0.75 11.5 0.75Z",
			stroke: "black",
			strokeOpacity: .12,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 0.75C39.2216 0.75 41.9062 3.07774 43.9551 7.35352C45.9778 11.5749 47.25 17.4595 47.25 24C47.25 30.5405 45.9778 36.4251 43.9551 40.6465C41.9062 44.9223 39.2216 47.25 36.5 47.25C33.7784 47.25 31.0938 44.9223 29.0449 40.6465C27.0222 36.4251 25.75 30.5405 25.75 24C25.75 17.4595 27.0222 11.5749 29.0449 7.35352C31.0938 3.07774 33.7784 0.75 36.5 0.75Z",
			stroke: "black",
			strokeOpacity: .12,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 19C6.8759 19 7.68491 19.4234 8.34375 20.1396C7.56189 20.4794 7 21.407 7 22.5C7 23.8807 7.89543 25 9 25C9.36215 25 9.70017 24.8774 9.99316 24.667C9.99719 24.7772 10 24.8882 10 25C10 28.3137 8.20911 31 6 31C3.79089 31 2 28.3137 2 25C2 21.6863 3.79089 19 6 19Z",
			fill: "#A8AAE3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 19C31.8759 19 32.6849 19.4234 33.3438 20.1396C32.5619 20.4794 32 21.407 32 22.5C32 23.8807 32.8954 25 34 25C34.3621 25 34.7002 24.8774 34.9932 24.667C34.9972 24.7772 35 24.8882 35 25C35 28.3137 33.2091 31 31 31C28.7909 31 27 28.3137 27 25C27 21.6863 28.7909 19 31 19Z",
			fill: "#A8AAE3"
		})
	]
});
export default SvgEyesLight;
